export default __webpack_public_path__ + "static/media/sep2023-4.27a7c0e5.jpg";